<template>
  <svg xmlns="http://www.w3.org/2000/svg"
       :width="width"
       :height="height"
       viewBox="0 0 16 16"
       @click="$emit('click')">
    <path :fill="disabled ? disabledStateColor : iconColor" fill-rule="nonzero" d="M13.823 5.47l.707.707-6.353 6.353-6.354-6.353.707-.707 5.647 5.646z"/>
  </svg>
</template>

<script>
  import iconMixin from './iconMixin.js'

  export default {
    mixins: [iconMixin]
  }
</script>
